import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../state/AuthContext";
import type { Role } from "../api/types";

interface RoleGateProps {
  allow: Role[];
  children: ReactNode;
}

export function RoleGate({ allow, children }: RoleGateProps) {
  const { hasRole } = useAuth();
  if (!hasRole(...allow)) {
    return <Navigate to="/app" replace />;
  }
  return <>{children}</>;
}
